import React from "react";

function BalEntryToPrisoner() {
  return (
    <div className="bg-bal-entry-to-prisoner py-5">
      <div className="container">
        <div>
          <h2 className="text-h-black text-light">Upon Entering the Prison</h2>
        </div>

        <div className="row row-cols-1 row-cols-md-3 g-4 my-5">
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h3 className="card-title text-hp-orange">
                  “When they first arrive, those prisoners who have connections
                  are not bothered by wardens, but if they don’t then they could
                  be slapped, or hit with a baton.”
                </h3>
              </div>
              <div className="card-footer">
                <small className="text-muted">- Feroze Bugti</small>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h3 className="card-title text-hp-orange">
                  “Based on the behaviour of the entrants, the guards will scare
                  them into shape, so they don’t raise their voices, or fight,
                  or behave badly with others.”
                </h3>
              </div>
              <div className="card-footer">
                <small className="text-muted">- Feroze Bugti</small>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h3 className="card-title text-hp-orange">
                  “In Dera Murad Jamali District Jail, there was no roof and
                  water would leak through when it rained. The walls had no
                  paint. There were frequent electricity outages.”
                </h3>
              </div>
              <div className="card-footer">
                <small className="text-muted">- Feroze Bugti</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BalEntryToPrisoner;
